import { render, staticRenderFns } from "./SchemaOptionalSettings.vue?vue&type=template&id=7cedeace&scoped=true"
import script from "./SchemaOptionalSettings.vue?vue&type=script&lang=js"
export * from "./SchemaOptionalSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cedeace",
  null
  
)

export default component.exports